var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 114,
    viewBox: "0 0 285 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_420_273)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_420_273",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 285,
    height: 114
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M285 0H0V114H285V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_420_273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.465 12.78C270.937 7.24486 263.58 4.19238 255.777 4.19238H29.2641C15.2824 4.19238 3.21092 14.1231 0.569025 27.8389L0.406446 28.5715V28.6529C0.121934 30.2809 0 31.9089 0 33.5369V84.7372C0 92.5515 3.04835 99.9182 8.57601 105.453C14.1037 110.989 21.4604 114.041 29.2641 114.041H255.777C263.58 114.041 270.937 110.989 276.465 105.453C281.992 99.9182 285.041 92.5515 285.041 84.7372V33.4962C285 25.6818 281.992 18.3152 276.465 12.78ZM277.643 84.6965C277.643 96.825 267.848 106.634 255.736 106.634H29.2641C17.1927 106.634 7.35667 96.825 7.35667 84.6965V33.4962C7.35667 32.0717 7.47861 30.6472 7.76312 29.3041C9.75471 19.2106 18.6152 11.5997 29.2641 11.5997H255.777C267.848 11.5997 277.684 21.4084 277.684 33.5369V84.6965H277.643Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.465 8.58765C270.937 3.05248 263.58 0 255.777 0H29.2641C15.2824 0 3.21092 9.93074 0.52838 23.6466L0.406446 24.3384V24.4198C0.121934 26.0478 0 27.6758 0 29.3038V80.5041C0 88.3185 3.04835 95.6851 8.57601 101.22C14.1037 106.755 21.4604 109.808 29.2641 109.808H255.777C263.58 109.808 270.937 106.755 276.465 101.22C281.992 95.6851 285.041 88.3185 285.041 80.5041V29.3038C285 21.4895 281.992 14.1228 276.465 8.58765ZM277.643 80.5041C277.643 92.6326 267.848 102.441 255.736 102.441H29.2641C17.1927 102.441 7.35667 92.6326 7.35667 80.5041V29.3038C7.35667 27.8793 7.47861 26.4548 7.76312 25.1117C9.75471 14.9775 18.6152 7.36665 29.2641 7.36665H255.777C267.848 7.36665 277.684 17.1753 277.684 29.3038V80.5041H277.643Z",
    fill: "#4DB567"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M276.465 8.58765C270.937 3.05248 263.58 0 255.777 0H29.2641C15.2824 0 3.21092 9.93074 0.52838 23.6466L0.406446 24.3384V24.4198C0.121934 26.0478 0 27.6758 0 29.3038V32.8854C0 31.2574 0.121934 29.6294 0.406446 28.0014V27.92L0.52838 27.2281C3.21092 13.5123 15.2824 3.58158 29.2641 3.58158H255.777C263.58 3.58158 270.937 6.63406 276.465 12.1692C281.992 17.7044 285.041 25.071 285.041 32.8854V29.3038C285 21.4895 281.992 14.1228 276.465 8.58765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.643 29.3034V80.5037C277.643 92.6322 267.848 102.441 255.736 102.441H29.2639C17.1924 102.441 7.35645 92.6322 7.35645 80.5037V29.3034C7.35645 27.8789 7.47838 26.4544 7.76289 25.1113C9.75448 14.9771 18.615 7.36621 29.2639 7.36621H255.776C267.848 7.36621 277.643 17.1749 277.643 29.3034Z",
    fill: "#56C773"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M231.511 12.8203H25.8496C25.8496 12.8203 45.1152 47.9849 100.026 38.5833C154.856 29.1409 182.047 15.2623 231.511 12.8203Z",
    fill: "url(#paint0_linear_420_273)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M51.1309 98.7785H256.793C256.793 98.7785 237.527 63.6139 182.616 73.0155C127.746 82.4579 100.555 96.3365 51.1309 98.7785Z",
    fill: "url(#paint1_linear_420_273)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.598 93.894C249.07 96.6209 261.467 95.8476 264.068 94.0568C266.629 92.3067 269.961 84.3702 267.035 83.1493C265.694 82.5795 250.127 91.1264 249.598 93.894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0604 11.7617C34.5075 9.48256 24.2244 10.5408 21.8263 11.5989C13.86 15.1398 16.8271 19.7796 19.3064 20.8378C20.4444 21.3262 33.6133 14.1223 34.0604 11.7617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3963 24.6235C15.9737 22.4664 12.966 21.5303 11.9499 22.4257C10.6493 23.5653 9.71442 31.2169 11.4621 31.0134C12.275 30.932 18.2498 25.9666 17.3963 24.6235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.519 103.784L188.184 107.406L192.858 109.808H187.168L184.689 106.796L181.519 103.784Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.519 103.784L184.16 107.732L183.876 109.767H187.168C187.168 109.808 183.632 105.412 181.519 103.784Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.979 3.05273L206.068 5.90172L206.271 7.36691H203.914C203.914 7.36691 206.475 4.23303 207.979 3.05273Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4834 109.808L93.7672 107.325L96.7749 103.377L96.0027 108.18L93.3201 109.808H88.4834Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7746 103.377L92.6289 106.633L84.1748 109.808H88.4831L93.7669 107.325L96.7746 103.377Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53.8457L2.43868 59.1367L6.42185 62.1484L1.58514 61.3345L0 58.689V53.8457Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42185 62.1483L3.17028 57.9968L0 49.5312V53.8455L2.43868 59.1364L6.42185 62.1483Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.74 7.36665H173.838C174.569 4.96537 175.098 2.48268 175.423 0H174.325C174 2.48268 173.472 4.92467 172.74 7.36665Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.533 0C202.37 2.48268 202.329 4.92467 202.411 7.36665H203.468C203.386 4.92467 203.427 2.44199 203.589 0H202.533Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.43 7.36665C120.024 4.88397 119.455 2.40129 118.723 0H117.626C118.358 2.40129 118.927 4.88397 119.374 7.36665H120.43Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.137 102.4C243.055 103.296 243.015 104.232 243.096 105.127C243.218 106.715 243.503 108.261 243.909 109.767H245.006C244.559 108.22 244.234 106.633 244.153 105.046C244.072 104.191 244.112 103.296 244.234 102.4H243.137Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.681 7.36665H250.737C251.063 4.92467 251.306 2.44199 251.388 0H250.372C250.25 2.48268 250.006 4.92467 249.681 7.36665Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2496 7.36665H77.3877C76.2496 4.80257 74.9084 2.36059 73.4045 0H72.1445C73.7297 2.36059 75.0709 4.80257 76.2496 7.36665Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M7.3571 89.2139C6.30034 84.2079 6.54421 79.1204 7.3571 74.0329V68.335C5.89389 75.3353 4.83713 82.4171 6.34098 89.4174C7.64161 95.441 11.0151 101.139 15.8925 105.453C16.9086 106.349 17.9653 107.163 19.0627 107.936C20.3227 108.424 21.664 108.791 22.9646 109.075C15.2422 105.168 9.22675 97.8423 7.3571 89.2139Z",
    fill: "#086D2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.644 44.9326V46.0722C280.407 47.5781 282.887 49.6131 285 51.933V50.4678C282.765 48.1886 280.285 46.3164 277.644 44.9326Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7539 109.645C76.8597 107.447 76.0061 105.005 75.3152 102.441H74.2178C74.9087 105.087 75.7623 107.57 76.6564 109.808H77.7945C77.8351 109.727 77.7945 109.686 77.7539 109.645Z",
    fill: "#086D2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.374 109.808C230.699 107.325 230.781 104.883 230.659 102.441H229.602C229.724 104.883 229.683 107.366 229.317 109.808H230.374Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.174 101.464C263.052 101.383 262.89 101.342 262.768 101.261C262.321 101.424 261.833 101.546 261.386 101.668C261.833 101.912 262.28 102.156 262.727 102.4C265.694 103.906 269.027 104.639 272.279 104.68C272.766 104.354 273.295 103.988 273.782 103.581C270.165 103.825 266.466 103.133 263.174 101.464Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.503 102.4H179.324C180.462 104.842 181.641 107.325 182.942 109.767H184.12C182.82 107.366 181.641 104.883 180.503 102.4Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5747 8.14035C22.7618 5.82046 22.0302 3.45988 21.5425 1.05859C21.2173 1.13999 20.8515 1.26209 20.5264 1.34349C21.0141 3.74478 21.7457 6.10536 22.5586 8.42525C22.8838 8.30315 23.2089 8.22175 23.5747 8.14035Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35716 29.9957V29.3038C7.35716 28.8561 7.35716 28.4084 7.39781 27.9607C5.73138 25.2339 3.69915 22.7105 1.34176 20.5127C1.21982 20.879 1.09789 21.2453 1.0166 21.6523C3.53657 24.0536 5.69073 26.9026 7.35716 29.9957Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.356 102.726C128.356 102.604 128.397 102.522 128.397 102.4H127.34C127.34 102.482 127.34 102.563 127.299 102.604C127.096 105.005 126.811 107.406 126.486 109.767H127.543C127.909 107.447 128.153 105.087 128.356 102.726Z",
    fill: "#088D2D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M47.148 108.912C48.977 107.04 50.0744 104.842 50.6434 102.4H49.546C49.0176 104.557 48.0015 106.511 46.4164 108.18C45.8067 108.79 45.1564 109.319 44.4248 109.767H46.2132C46.5383 109.523 46.8635 109.238 47.148 108.912Z",
    fill: "#086D2B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_420_273",
    x1: 110.624,
    y1: -45.9252,
    x2: 136.662,
    y2: 38.5821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9500F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_420_273",
    x1: 159.378,
    y1: 128.803,
    x2: 149.974,
    y2: 76.7907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9500F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_420_273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 285,
    height: 114,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenFrame);
export default __webpack_public_path__ + "static/media/GreenFrame.e24c6cab098af5ce1e36c9ade63f604b.svg";
export { ForwardRef as ReactComponent };